import { render, staticRenderFns } from "./EmailSender.vue?vue&type=template&id=795ef2fd&"
import script from "./EmailSender.vue?vue&type=script&lang=js&"
export * from "./EmailSender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports